export const useHotelImages = () => {
  const categories = [
    { code: 1, description: "Vista exterior" },
    { code: 2, description: "Lobby" },
    { code: 3, description: "Piscina" },
    { code: 4, description: "Restaurante" },
    { code: 5, description: "Salud" },
    { code: 6, description: "Habitación" },
    { code: 7, description: "Suite" },
    { code: 8, description: "Sala de juntas" },
    { code: 9, description: "Sala de eventos" },
    { code: 10, description: "Golf" },
    { code: 11, description: "Playa" },
    { code: 12, description: "Spa" },
    { code: 13, description: "Bar" },
    { code: 14, description: "Instalación recreativa" },
    { code: 15, description: "Logotipo" },
    { code: 16, description: "Básicos" },
    { code: 17, description: "Mapa" },
    { code: 18, description: "Promocional" },
    { code: 19, description: "Noticias destacadas" },
    { code: 20, description: "Misceláneo" },
    { code: 21, description: "Servicios de la habitación" },
    { code: 22, description: "Servicios del establecimiento" },
    { code: 23, description: "Centro de negocios" },
  ];

  const descriptions = [
    "Exterior view",
    "Lobby view",
    "Pool view",
    "Restaurant",
    "Health club",
    "Guest room",
    "Suite",
    "Meeting room",
    "Ballroom",
    "Golf course",
    "Beach",
    "Spa",
    "Bar/Lounge",
    "Recreational facility",
    "Logo",
    "Basics",
    "Map",
    "Promotional",
    "Hot news",
    "Miscellaneous",
    "Guest room amenity",
    "Property amenity",
    "Business center",
  ];

  const getImageCategory = (category: number) => {
    const categoryObject = categories.find((c) => c.code === category);
    return categoryObject ? categoryObject.description : "";
  };

  return {
    getImageCategory,
    categories,
    descriptions,
  };
};
